// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2169) return "ionic/shopping/main/2169.js";
	if (chunkId === 760) return "ionic/shopping/main/760.js";
	if (chunkId === 4692) return "ionic/shopping/main/4692.js";
	if (chunkId === 4394) return "ionic/shopping/main/4394.js";
	if (chunkId === 2635) return "ionic/shopping/main/2635.js";
	if (chunkId === 2725) return "ionic/shopping/main/2725.js";
	if (chunkId === 8336) return "ionic/shopping/main/8336.js";
	if (chunkId === 335) return "ionic/shopping/main/335.js";
	if (chunkId === 7559) return "ionic/shopping/main/7559.js";
	if (chunkId === 223) return "ionic/shopping/main/223.js";
	if (chunkId === 3937) return "ionic/shopping/main/3937.js";
	if (chunkId === 7327) return "ionic/shopping/main/7327.js";
	if (chunkId === 1188) return "ionic/shopping/main/1188.js";
	if (chunkId === 1760) return "ionic/shopping/main/1760.js";
	if (chunkId === 1448) return "ionic/shopping/main/1448.js";
	if (chunkId === 4605) return "ionic/shopping/main/4605.js";
	if (chunkId === 4788) return "ionic/shopping/main/4788.js";
	if (chunkId === 2748) return "ionic/shopping/main/2748.js";
	if (chunkId === 4505) return "ionic/shopping/main/4505.js";
	if (chunkId === 5579) return "ionic/shopping/main/5579.js";
	if (chunkId === 1762) return "ionic/shopping/main/1762.js";
	if (chunkId === 283) return "ionic/shopping/main/283.js";
	if (chunkId === 6978) return "ionic/shopping/main/6978.js";
	if (chunkId === 8063) return "ionic/shopping/main/8063.js";
	if (chunkId === 3735) return "ionic/shopping/main/3735.js";
	// return url for filenames based on template
	return undefined;
};